import { createSlice } from 'core/use-cases/utilities';

import { initialState } from './initial-state';
import { updatePathname } from './action';

const routerSlice = createSlice({
  name: 'router',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(updatePathname, (state, { payload = '' }) => {
      state.prevPathname = state.currentPathname;
      state.currentPathname = payload;
    });
  },
});

export const { reducer } = routerSlice;
